import React, { FC, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AnimatedScreen, LoadingPage, PageHeader } from 'Shared/components';
import { PartnerContext } from 'Admin/utils';

export const List: FC = () => {
  const history = useHistory();
  const { loading, currentPartner } = useContext(PartnerContext);

  if (loading) return <LoadingPage />;

  if (!currentPartner) {
    return null;
  }

  return (
    <AnimatedScreen testId="commissions-list-screen">
      <PageHeader
        onActionClick={() => {
          history.push(`${history.location.pathname}/create`);
        }}
        actionName="Create Commission"
        actionTestId="create-commission-button"
        heading="Commissions"
      />
    </AnimatedScreen>
  );
};
